import React, { useState, useEffect } from "react";

import axios from "axios";

const Gateway = () => {
  const [RazorPayout, setRazorpayout] = useState(true);
  const [RazorDeposit, setRazorDeposit] = useState(true);
  const [RazorpayAuto, setRazorpayAuto] = useState(false);
  const [RazorPayKey, setRazorpayKey] = useState("");
  const [RazorPaySecretKey, setRazorpaysecretKey] = useState("");
  const [AccountName, setAccountName] = useState("");
  const [decentroPayout, setdecentropayout] = useState(true);
  const [decentroDeposit, setdecentroDeposit] = useState(true);
  const [decentroAuto, setdecentroAuto] = useState(false);
  const [settingId, setSettingId] = useState("");

  // UPI States
  const [UPIEnabled, setUPIEnabled] = useState(true);
  const [UPIGatewayKey, setUPIGatewayKey] = useState("");
  const [UPIGatewaySecret, setUPIGatewaySecret] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Fast2SMS States
  const [fast2smsKey, setFast2smsKey] = useState("");
  const [Fast2SMSEnabled, setFast2SMSEnabled] = useState(true);

  // Twilio States
  const [TwilioEnabled, setTwilioEnabled] = useState(true);
  const [TwilioAccountSid, setTwilioAccountSid] = useState("");
  const [TwilioAuthToken, setTwilioAuthToken] = useState("");
  const [TwilioPhoneNumber, setTwilioPhoneNumber] = useState("");

  // OTPless States
  const [OTPlessEnabled, setOTPlessEnabled] = useState(false);
  const [OTPlessClientId, setOTPlessClientId] = useState("");
  const [OTPlessClientSecret, setOTPlessClientSecret] = useState("");
  const [OTPlessEnvironment, setOTPlessEnvironment] = useState("production");

  // SMSINDIAHUB States
  const [SMSINDIAHUBEnabled, setSMSINDIAHUBEnabled] = useState(false);
  const [SMSINDIAHUBAPIKey, setSMSINDIAHUBAPIKey] = useState("");
  const [SMSINDIAHUBSID, setSMSINDIAHUBSID] = useState("");
  const [SMSINDIAHUBName, setSMSINDIAHUBName] = useState("");

  // AllAPI States
  const [AllAPIEnabled, setAllAPIEnabled] = useState(false);
  const [AllAPIToken, setAllAPIToken] = useState("");
  const [AllAPISecretKey, setAllAPISecretKey] = useState("");
  const [AllAPIRedirectUrl, setAllAPIRedirectUrl] = useState("");

  const backendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const backendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = backendLocalApiUrl;
  } else {
    baseUrl = backendLiveApiUrl;
  }

  useEffect(() => {
    const data = axios.get(baseUrl + "gatewaysettings/data", {}).then((res) => {
      if (res.data) {
        setSettingId((res.data._id) ? res.data._id : '');
        setRazorpayout(res.data.RazorPayout !== undefined && res.data.RazorPayout !== null ? res.data.RazorPayout : true);
        setRazorDeposit(res.data.RazorDeposit !== undefined && res.data.RazorDeposit !== null ? res.data.RazorDeposit : true);
        setRazorpayAuto(res.data.RazorpayAuto !== undefined && res.data.RazorpayAuto !== null ? res.data.RazorpayAuto : false);
        setdecentropayout(res.data.decentroPayout !== undefined && res.data.decentroPayout !== null ? res.data.decentroPayout : true);
        setdecentroDeposit(res.data.decentroDeposit !== undefined && res.data.decentroDeposit !== null ? res.data.decentroDeposit : true);
        setdecentroAuto(res.data.decentroAuto !== undefined && res.data.decentroAuto !== null ? res.data.decentroAuto : false);
        setRazorpayKey(res.data.RazorPayKey || "");
        setRazorpaysecretKey(res.data.RazorPaySecretKey || "");
        setAccountName(res.data.AccountName || "");

        // UPI Data
        setUPIEnabled(res.data.UPIEnabled !== undefined ? res.data.UPIEnabled : true);
        setUPIGatewayKey(res.data.UPIGatewayKey || "");
        setUPIGatewaySecret(res.data.UPIGatewaySecret || "");

        // Fast2SMS Data
        setFast2smsKey(res.data.fast2smsKey || "");
        setFast2SMSEnabled(res.data.Fast2SMSEnabled !== undefined ? res.data.Fast2SMSEnabled : true);

        // Twilio Data
        setTwilioEnabled(res.data.TwilioEnabled !== undefined ? res.data.TwilioEnabled : true);
        setTwilioAccountSid(res.data.TwilioAccountSid || "");
        setTwilioAuthToken(res.data.TwilioAuthToken || "");
        setTwilioPhoneNumber(res.data.TwilioPhoneNumber || "");

        // OTPless Data
        setOTPlessEnabled(res.data.OTPlessEnabled !== undefined ? res.data.OTPlessEnabled : false);
        setOTPlessClientId(res.data.OTPlessClientId || "");
        setOTPlessClientSecret(res.data.OTPlessClientSecret || "");
        setOTPlessEnvironment(res.data.OTPlessEnvironment || "production");

        // SMSINDIAHUB Data
        setSMSINDIAHUBEnabled(res.data.SMSINDIAHUBEnabled !== undefined ? res.data.SMSINDIAHUBEnabled : false);
        setSMSINDIAHUBAPIKey(res.data.SMSINDIAHUBAPIKey || "");
        setSMSINDIAHUBSID(res.data.SMSINDIAHUBSID || "");
        setSMSINDIAHUBName(res.data.SMSINDIAHUBName || "");

        // AllAPI Data
        setAllAPIEnabled(res.data.AllAPIEnabled !== undefined ? res.data.AllAPIEnabled : false);
        setAllAPIToken(res.data.AllAPIToken || "");
        setAllAPISecretKey(res.data.AllAPISecretKey || "");
        setAllAPIRedirectUrl(res.data.AllAPIRedirectUrl || "");
      }
    }).catch(err => console.error(err));
  }, []);

  const handleUPIToggle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings/toggle-upi");
      if (response.data.status === 'success') {
        setUPIEnabled(response.data.data.UPIEnabled);
        alert(response.data.message);
      } else {
        alert("Failed to toggle UPI status");
      }
    } catch (error) {
      console.error("Error toggling UPI:", error);
      alert("Error toggling UPI status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleFast2SMSToggle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings/toggle-fast2sms");
      if (response.data.status === 'success') {
        setFast2SMSEnabled(response.data.data.Fast2SMSEnabled);
        setTwilioEnabled(response.data.data.TwilioEnabled); // Update Twilio state too
        setOTPlessEnabled(response.data.data.OTPlessEnabled); // Update OTPless state too
        setSMSINDIAHUBEnabled(response.data.data.SMSINDIAHUBEnabled); // Update SMSINDIAHUB state too
        alert(response.data.message);
      } else {
        alert("Failed to toggle Fast2SMS status");
      }
    } catch (error) {
      console.error("Error toggling Fast2SMS:", error);
      alert("Error toggling Fast2SMS status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleTwilioToggle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings/toggle-twilio");
      if (response.data.status === 'success') {
        setTwilioEnabled(response.data.data.TwilioEnabled);
        setFast2SMSEnabled(response.data.data.Fast2SMSEnabled); // Update Fast2SMS state too
        setOTPlessEnabled(response.data.data.OTPlessEnabled); // Update OTPless state too
        setSMSINDIAHUBEnabled(response.data.data.SMSINDIAHUBEnabled); // Update SMSINDIAHUB state too
        alert(response.data.message);
      } else {
        alert("Failed to toggle Twilio status");
      }
    } catch (error) {
      console.error("Error toggling Twilio:", error);
      alert("Error toggling Twilio status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleOTPlessToggle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings/toggle-otpless");
      if (response.data.status === 'success') {
        setOTPlessEnabled(response.data.data.OTPlessEnabled);
        setFast2SMSEnabled(response.data.data.Fast2SMSEnabled); // Update Fast2SMS state too
        setTwilioEnabled(response.data.data.TwilioEnabled); // Update Twilio state too
        setSMSINDIAHUBEnabled(response.data.data.SMSINDIAHUBEnabled); // Update SMSINDIAHUB state too
        alert(response.data.message);
      } else {
        alert("Failed to toggle OTPless status");
      }
    } catch (error) {
      console.error("Error toggling OTPless:", error);
      alert("Error toggling OTPless status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSMSINDIAHUBToggle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings/toggle-smsindiahub");
      if (response.data.status === 'success') {
        setSMSINDIAHUBEnabled(response.data.data.SMSINDIAHUBEnabled);
        setFast2SMSEnabled(response.data.data.Fast2SMSEnabled); // Update Fast2SMS state too
        setTwilioEnabled(response.data.data.TwilioEnabled); // Update Twilio state too
        setOTPlessEnabled(response.data.data.OTPlessEnabled); // Update OTPless state too
        alert(response.data.message);
      } else {
        alert("Failed to toggle SMSINDIAHUB status");
      }
    } catch (error) {
      console.error("Error toggling SMSINDIAHUB:", error);
      alert("Error toggling SMSINDIAHUB status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAllAPIToggle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings/toggle-allapi");
      if (response.data.status === 'success') {
        setAllAPIEnabled(response.data.data.AllAPIEnabled);
        alert(response.data.message);
      } else {
        alert("Failed to toggle AllAPI status");
      }
    } catch (error) {
      console.error("Error toggling AllAPI:", error);
      alert("Error toggling AllAPI status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit1 = async (e) => {
    e.preventDefault();

    const response = await axios.post(
      baseUrl + `gatewaysettings`,
      {
        settingId,
        RazorPayout,
        RazorDeposit,
        RazorpayAuto,
        decentroPayout,
        decentroDeposit,
        decentroAuto,
        RazorPayKey,
        RazorPaySecretKey,
        AccountName,
        UPIEnabled,
        UPIGatewayKey,
        UPIGatewaySecret,
        fast2smsKey,
        Fast2SMSEnabled,
        TwilioEnabled,
        TwilioAccountSid,
        TwilioAuthToken,
        TwilioPhoneNumber,
        OTPlessEnabled,
        OTPlessClientId,
        OTPlessClientSecret,
        OTPlessEnvironment,
        SMSINDIAHUBEnabled,
        SMSINDIAHUBAPIKey,
        SMSINDIAHUBSID,
        SMSINDIAHUBName,
        AllAPIEnabled,
        AllAPIToken,
        AllAPISecretKey,
        AllAPIRedirectUrl,
      }
    );
    if (response.data.status === 'success') {
      alert("Settings submitted successfully");
    } else {
      alert("Settings Not Submitted");
    }
  };

  return (
    <>
      <h5 className="text-uppercase font-weight-bold my-3">UPI Gateway</h5>
      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
        style={{ backgroundColor: "rgba(0, 27, 11, 0.734)", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '120px', color: 'white' }}>
                UPI Status:
              </label>
              <button
                type="button"
                className={`btn ${UPIEnabled ? 'btn-success' : 'btn-danger'} ${isLoading ? 'disabled' : ''}`}
                onClick={handleUPIToggle}
                disabled={isLoading}
                style={{
                  minWidth: '100px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                ) : null}
                {UPIEnabled ? 'Active' : 'Disabled'}
              </button>
              <span className="ml-3 text-light">
                {UPIEnabled ? 'UPI payments are currently enabled' : 'UPI payments are currently disabled'}
              </span>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="UPIGatewayKey" style={{ color: 'white' }}>UPI Gateway Key</label>
            <input
              className="form-control"
              type="text"
              value={UPIGatewayKey}
              onChange={(e) => setUPIGatewayKey(e.target.value)}
              placeholder="Enter UPI Gateway Key"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              Update UPI Settings
            </button>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3">AllAPI Payment Gateway</h5>
      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
        style={{ backgroundColor: "rgba(27, 0, 27, 0.734)", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '120px', color: 'white' }}>
                AllAPI Status:
              </label>
              <button
                type="button"
                className={`btn ${AllAPIEnabled ? 'btn-success' : 'btn-danger'} ${isLoading ? 'disabled' : ''}`}
                onClick={handleAllAPIToggle}
                disabled={isLoading}
                style={{
                  minWidth: '100px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                ) : null}
                {AllAPIEnabled ? 'Active' : 'Disabled'}
              </button>
              <span className="ml-3 text-light">
                AllAPI Payment Gateway is currently {AllAPIEnabled ? 'enabled' : 'disabled'}
              </span>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="AllAPIToken" style={{ color: 'white' }}>AllAPI Token</label>
            <input
              className="form-control"
              type="text"
              value={AllAPIToken}
              onChange={(e) => setAllAPIToken(e.target.value)}
              placeholder="Enter AllAPI Token"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              Update AllAPI Settings
            </button>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3">Fast2SMS Gateway</h5>
      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
        style={{ backgroundColor: "rgba(27, 0, 11, 0.734)", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '120px', color: 'white' }}>
                Fast2SMS Status:
              </label>
              <button
                type="button"
                className={`btn ${Fast2SMSEnabled ? 'btn-success' : 'btn-danger'} ${isLoading ? 'disabled' : ''}`}
                onClick={handleFast2SMSToggle}
                disabled={isLoading}
                style={{
                  minWidth: '100px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                ) : null}
                {Fast2SMSEnabled ? 'Active' : 'Disabled'}
              </button>
              <span className="ml-3 text-light">
                Fast2SMS is currently {Fast2SMSEnabled ? 'enabled' : 'disabled'} for OTP delivery
              </span>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-6">
            <label htmlFor="fast2smsKey" style={{ color: 'white' }}>Fast2SMS API Key</label>
            <input
              className="form-control"
              type="text"
              value={fast2smsKey}
              onChange={(e) => setFast2smsKey(e.target.value)}
              placeholder="Enter Fast2SMS API Key"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              Update Fast2SMS Settings
            </button>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3">Twilio Gateway</h5>
      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
        style={{ backgroundColor: "rgba(0, 11, 27, 0.734)", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '120px', color: 'white' }}>
                Twilio Status:
              </label>
              <button
                type="button"
                className={`btn ${TwilioEnabled ? 'btn-success' : 'btn-danger'} ${isLoading ? 'disabled' : ''}`}
                onClick={handleTwilioToggle}
                disabled={isLoading}
                style={{
                  minWidth: '100px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                ) : null}
                {TwilioEnabled ? 'Active' : 'Disabled'}
              </button>
              <span className="ml-3 text-light">
                Twilio is currently {TwilioEnabled ? 'enabled' : 'disabled'} for SMS delivery
              </span>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="TwilioAccountSid" style={{ color: 'white' }}>Twilio Account SID</label>
            <input
              className="form-control"
              type="text"
              value={TwilioAccountSid}
              onChange={(e) => setTwilioAccountSid(e.target.value)}
              placeholder="Enter Twilio Account SID"
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="TwilioAuthToken" style={{ color: 'white' }}>Twilio Auth Token</label>
            <input
              className="form-control"
              type="text"
              value={TwilioAuthToken}
              onChange={(e) => setTwilioAuthToken(e.target.value)}
              placeholder="Enter Twilio Auth Token"
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="TwilioPhoneNumber" style={{ color: 'white' }}>Twilio Phone Number</label>
            <input
              className="form-control"
              type="text"
              value={TwilioPhoneNumber}
              onChange={(e) => setTwilioPhoneNumber(e.target.value)}
              placeholder="Enter Twilio Phone Number"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              Update Twilio Settings
            </button>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3">OTPless Gateway</h5>
      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
        style={{ backgroundColor: "rgba(27, 27, 0, 0.734)", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '120px', color: 'white' }}>
                OTPless Status:
              </label>
              <button
                type="button"
                className={`btn ${OTPlessEnabled ? 'btn-success' : 'btn-danger'} ${isLoading ? 'disabled' : ''}`}
                onClick={handleOTPlessToggle}
                disabled={isLoading}
                style={{
                  minWidth: '100px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                ) : null}
                {OTPlessEnabled ? 'Active' : 'Disabled'}
              </button>
              <span className="ml-3 text-light">
                OTPless is currently {OTPlessEnabled ? 'enabled' : 'disabled'} for SMS delivery
              </span>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="OTPlessClientId" style={{ color: 'white' }}>OTPless Client ID</label>
            <input
              className="form-control"
              type="text"
              value={OTPlessClientId}
              onChange={(e) => setOTPlessClientId(e.target.value)}
              placeholder="Enter OTPless Client ID"
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="OTPlessClientSecret" style={{ color: 'white' }}>OTPless Client Secret</label>
            <input
              className="form-control"
              type="password"
              value={OTPlessClientSecret}
              onChange={(e) => setOTPlessClientSecret(e.target.value)}
              placeholder="Enter OTPless Client Secret"
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="OTPlessEnvironment" style={{ color: 'white' }}>Environment</label>
            <select
              className="form-control"
              value={OTPlessEnvironment}
              onChange={(e) => setOTPlessEnvironment(e.target.value)}
            >
               <option value="production">Production</option>
               <option value="sandbox">Sandbox</option>
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              Update OTPless Settings
            </button>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3">SMSINDIAHUB Gateway</h5>
      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
        style={{ backgroundColor: "rgba(0, 27, 27, 0.734)", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '120px', color: 'white' }}>
                SMSINDIAHUB Status:
              </label>
              <button
                type="button"
                className={`btn ${SMSINDIAHUBEnabled ? 'btn-success' : 'btn-danger'} ${isLoading ? 'disabled' : ''}`}
                onClick={handleSMSINDIAHUBToggle}
                disabled={isLoading}
                style={{
                  minWidth: '100px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                ) : null}
                {SMSINDIAHUBEnabled ? 'Active' : 'Disabled'}
              </button>
              <span className="ml-3 text-light">
                SMSINDIAHUB is currently {SMSINDIAHUBEnabled ? 'enabled' : 'disabled'} for SMS delivery
              </span>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="SMSINDIAHUBAPIKey" style={{ color: 'white' }}>SMSINDIAHUB API Key</label>
            <input
              className="form-control"
              type="text"
              value={SMSINDIAHUBAPIKey}
              onChange={(e) => setSMSINDIAHUBAPIKey(e.target.value)}
              placeholder="Enter SMSINDIAHUB API Key"
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="SMSINDIAHUBSID" style={{ color: 'white' }}>SMSINDIAHUB SID</label>
            <input
              className="form-control"
              type="text"
              value={SMSINDIAHUBSID}
              onChange={(e) => setSMSINDIAHUBSID(e.target.value)}
              placeholder="Enter SMSINDIAHUB SID"
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="SMSINDIAHUBName" style={{ color: 'white' }}>SMSINDIAHUB Name</label>
            <input
              className="form-control"
              type="text"
              value={SMSINDIAHUBName}
              onChange={(e) => setSMSINDIAHUBName(e.target.value)}
              placeholder="Enter SMSINDIAHUB Name (e.g., 22222)"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              Update SMSINDIAHUB Settings
            </button>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3">RazorPay</h5>

      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
      >
        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="buttonrazpay">Razorpay Payout</label>
            <select
              id="buttonrazpay"
              className="form-control"
              value={RazorPayout}
              onChange={(e) => setRazorpayout(e.target.value === "true")}
            >
              <option value="true">Enable</option>
              <option value="false">Disable</option>
            </select>
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="buttonrazdep">Razorpay Deposit</label>
            <select
              id="buttonrazdep"
              className="form-control"
              value={RazorDeposit}
              onChange={(e) => setRazorDeposit(e.target.value === "true")}
            >
              <option value="true">Enable</option>
              <option value="false">Disable</option>
            </select>
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="buttonrazauto">RazorPay Auto</label>
            <select
              id="buttonrazauto"
              className="form-control"
              value={RazorpayAuto}
              onChange={(e) => setRazorpayAuto(e.target.value === "true")}
            >
              <option value="true">Enable</option>
              <option value="false">Disable</option>
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="RazorpayKey">RazorPay Key</label>
            <input
              className="form-control"
              type="text"
              value={RazorPayKey}
              onChange={(e) => setRazorpayKey(e.target.value)}
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="RazorpaysecretKey">RazorPay SecretKey</label>
            <input
              className="form-control"
              type="text"
              value={RazorPaySecretKey}
              onChange={(e) => setRazorpaysecretKey(e.target.value)}
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="AccountName">Account Name</label>
            <input
              className="form-control"
              type="text"
              value={AccountName}
              onChange={(e) => setAccountName(e.target.value)}
            />
          </div>
        </div>

        {/* <div className="form-row">
          <div className="form-group col-md-4">
            <h5 className="text-uppercase font-weight-bold my-3">Decentro</h5>

            <label htmlFor="buttondecpay" className="col-2 my-1">
              Decentro payout
            </label>
            <select
              className="form-control "
              name=""
              id=""
              value={decentroPayout}
              onChange={(e) => setdecentropayout(e.target.value)}
            >
              <option value="true">Enable</option>
              <option value="false">Disable</option>
            </select>

            <label htmlFor="buttondecdep" className="col-2 my-1">
              Decentro Deposit
            </label>
            <select
              className="form-control "
              name=""
              id=""
              value={decentroDeposit}
              onChange={(e) => setdecentroDeposit(e.target.value)}
            >
              <option value="true">Enable</option>
              <option value="false">Disable</option>
            </select>

            <label htmlFor="buttondecdep" className="col-2 my-1">
              Decentro Auto
            </label>
            <select
              className="form-control "
              name=""
              id=""
              value={decentroAuto}
              onChange={(e) => setdecentroAuto(e.target.value)}
            >
              <option value="true">Enable</option>
              <option value="false">Disable</option>
            </select>
          </div>
        </div> */}

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              RazorPay Settings Update
            </button>
          </div>
        </div>


      </form>
    </>
  );
};

export default Gateway;
